import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Auto = () => {
  const data = [
    {
      subjectName: "2021 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1Fmegs_pU7m9_bddjFOPLDFAePWWPG81E/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2022 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1Fmegs_pU7m9_bddjFOPLDFAePWWPG81E/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">BME Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Auto;
